var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ayuda-tema-base',{attrs:{"busqueda":_vm.busqueda,"color":_vm.color,"faqs":_vm.faqs}})
}
var staticRenderFns = []

export { render, staticRenderFns }